export const timerRedo = 8000;